import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import { versionWatcher } from '../../utils/appVersion';

// CREW-1289 — shown when this tab runs an older build than the one deployed
// (src/utils/appVersion.js). It stays until acted on: the app's toasts vanish
// after 5 s and carry no action. It never reloads by itself — the person may
// be half-way through a form; "Later" hides it until the next check finds the
// tab still stale.

const MESSAGES = {
  deployed: 'A new version of CREWISOR is available.',
  chunk: 'This page could not be loaded — a new version of CREWISOR is available.',
};

const NewVersionNotice = ({ watcher = versionWatcher, reload = () => window.location.reload() }) => {
  const [reason, setReason] = useState(null);

  // A page that failed to load is the more urgent message; a later routine
  // check must not downgrade it.
  useEffect(() => watcher.subscribe((next) => setReason((current) => (current === 'chunk' ? current : next))), [watcher]);

  return (
    <Snackbar
      open={Boolean(reason)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message={MESSAGES[reason] || MESSAGES.deployed}
      action={(
        <>
          <Button color="inherit" size="small" onClick={() => setReason(null)}>Later</Button>
          <Button color="primary" variant="contained" size="small" onClick={reload}>Reload</Button>
        </>
      )}
    />
  );
};

NewVersionNotice.propTypes = {
  watcher: PropTypes.shape({ subscribe: PropTypes.func.isRequired }),
  reload: PropTypes.func,
};

export default NewVersionNotice;
